import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import MainLayout from './components/layout/MainLayout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Bottles from './pages/Bottles';
import BottleDetail from './pages/BottleDetail';
import Distilleries from './pages/Distilleries';
import DistilleryDetail from './pages/DistilleryDetail';
import Utilities from './pages/Utilities';
import Hunt from './pages/Hunt';
import SharedCollection from './pages/SharedCollection';
import SharedHunt from './pages/SharedHunt';
import SharedDashboard from './pages/SharedDashboard';
import ResetPassword from './pages/ResetPassword';
import NotFound from './pages/NotFound';
import LoadingSpinner from './components/common/LoadingSpinner';
import UpdatePrompt from './components/common/UpdatePrompt';

/**
 * Protected route wrapper that redirects to login if not authenticated
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Child components to render
 * @returns {React.ReactElement} Protected content or redirect
 */
function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return <LoadingSpinner fullScreen />;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return children;
}


/**
 * Main application component with routing configuration
 * @returns {React.ReactElement} Application routes
 */
function App() {
  return (
    <>
    <UpdatePrompt />
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <MainLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="bottles" element={<Bottles />} />
        <Route path="bottles/:id" element={<BottleDetail />} />
        <Route path="distilleries" element={<Distilleries />} />
        <Route path="distilleries/:id" element={<DistilleryDetail />} />
        <Route path="hunt" element={<Hunt />} />
        <Route path="settings" element={<Utilities />} />
        <Route path="shared/:shareId/dashboard" element={<SharedDashboard />} />
        <Route path="shared/:shareId/bottles" element={<SharedCollection />} />
        <Route path="shared/:shareId/hunt" element={<SharedHunt />} />
      </Route>
      <Route path="*" element={<NotFound />} />
    </Routes>
    </>
  );
}

export default App;
